
import api from '@/apis/api'
import axios from 'axios'
import { format, formatDistanceToNow } from 'date-fns'
import isAfter from 'date-fns/isAfter'
import Vue from 'vue'
import Component from 'vue-class-component'

const CouponProps = Vue.extend({
  props: {
    id: String,
    name: String,
    description: String,
    expiry: Date,
    redeemedOn: Date,
    redemptionStore: String,
  },
})

@Component({
  inheritAttrs: false,
})
export default class Coupon extends CouponProps {
  storeNumber = this.$store.state.State.s.user.storeNumber
  checkNumber = ''
  discount = ''
  subtotal = ''
  guestCount = '1'
  comments = ''

  redeemingCoupon = false
  redeemed = false

  get formValid(): boolean {
    return (
      parseInt(this.storeNumber) > 0 &&
      parseInt(this.checkNumber) > 0 &&
      parseFloat(this.subtotal) > 0 &&
      parseFloat(this.discount) > 0 &&
      parseInt(this.guestCount) > 0
    )
  }

  get isCouponValid(): boolean {
    return this.redeemedOn == null
  }

  get redeemedOnDate(): Date {
    return new Date(Date.parse(this.redeemedOn))
  }

  get expiryDate(): Date {
    return new Date(Date.parse(this.expiry))
  }

  get isExpired(): boolean {
    return isAfter(new Date(), this.expiryDate)
  }

  get isRedeemable(): boolean {
    return this.isCouponValid && !this.isExpired
  }

  ago(date: Date): string {
    return formatDistanceToNow(date, { addSuffix: true })
  }

  format(date: Date): string {
    return format(date, 'yyyy-MM-dd h:mm aaaa')
  }

  async redeem(): Promise<void> {
    try {
      this.redeemingCoupon = true
      await api.redeemCoupon(this.id, {
        checkNumber: parseInt(this.checkNumber),
        subtotal: parseInt(this.subtotal),
        discount: parseFloat(this.discount),
        guestCount: parseInt(this.guestCount),
        comments: this.comments,
      })
      this.redeemed = true
    } catch (e) {
      if (axios.isAxiosError(e) && e.response?.status === 404) {
        this.$store.dispatch('snackbar', {
          message: "We're sorry, this offer code entered has already been redeemed",
          isError: true,
        })
      } else {
        this.$store.dispatch('snackbar', { message: e, isError: true })
      }
    } finally {
      this.redeemingCoupon = false
    }
  }
}
